<template>
  <div>
    <v-autocomplete
      @change="handleSelect"
      :label="$t('customer.label.serviceType')"
      :no-data-text="$t('table.noResults')"
      :disabled="disable"
      :items="services"
      :rules="rules"
      :value="value"
      item-value="value"
      item-text="name"
      hide-details="auto"
      deletable-chips
      small-chips
      clearable
      multiple
      outlined
      chips
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { icons } from '@/util/iconsSVG'

export default {
  name: 'RealEstateServiceTypeSelect',

  props: {
    rules: {
      required: false
    },
    value: Array,
    disable: {
      default: false
    }
  },

  async mounted(){
    await this.fetchHostServiceTypes()
  },

  computed: {
    ...mapGetters(['hostServiceTypes', 'isLoading']),

    services() {
      const services = []
      this.hostServiceTypes.map((service) => services.push({ name:  this.$t(`type.${service}`), value: service}))
      services.sort((service1, service2) => (service1.name > service2.name) ? 1 : (service1.name < service2.name) ? -1 : 0);

      return services
    }
  },

  methods: {
    ...mapActions(['fetchHostServiceTypes']),

    handleSelect(value) {
      this.$emit('input', value)
    },

    handleGetIcon(type) {
      return icons[type]
    },
  },

  data() {
    return {
      selectedServiceTypes: [],
    }
  },
}
</script>
